import { styled } from "@phntms/css-components";
import {marginVariants, textVariants} from "../../style-variants";

export const H1 = styled('h1', {
  css: [],
  variants: {
    size: {
      big: ['title-big'],
      medium: ['title'],
      small: ['title-small'],
      xsmall: ['title-xsmall'],
    },
    ...textVariants,
    ...marginVariants,
  },
  defaultVariants: {
    size: 'big',
  }
})

export const H2 = styled('h2', {
  css: ['title'],
  variants: {
    ...textVariants,
    ...marginVariants
  }
})

export const H3 = styled('h3', {
  css: ['title-small'],
  variants: {
    ...textVariants,
    ...marginVariants
  }
})

export const Paragraph = styled('p', {
  css: ['paragraph-txt'],
  variants: {
    ...textVariants,
    ...marginVariants
  }
})

export const BigText = styled('p', {
  css: ['big-txt'],
  variants: {
    ...textVariants,
    ...marginVariants
  }
})

export const MediumText = styled('p', {
  css: ['medium-txt'],
  variants: {
    ...textVariants,
    ...marginVariants
  }
})

export const Body = styled('p', {
  css: ['body-txt'],
  variants: {
    ...textVariants,
    ...marginVariants
  }
})

export const Caption = styled('p', {
  css: ['caption-txt'],
  variants: {
    ...textVariants,
    ...marginVariants
  }
})





